module.exports = __webpack_public_path__ + "img/meter-reset.4f23b167.png";